import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { ReportContext, ReportDefinition } from './report.models';
import { resolveReportDefinition } from './report.registry';

@Component({ selector: 'report', templateUrl: './report.component.html' })
export class ReportComponent implements OnInit, OnDestroy {
  context: ReportContext | null = null;
  definition: ReportDefinition | null = null;
  private routeSubscription?: Subscription;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly gurdService: GurdServiceService,
    private readonly location: Location,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe((params) => {
      this.context = {
        id: String(params['id'] ?? ''),
        type: String(params['type'] ?? '0'),
        polygonId: params['polygan'] ? String(params['polygan']) : null,
        startDate: this.decryptStorage('reportDataZa'),
        endDate: this.decryptStorage('reportDataTa'),
        startTime: this.decryptStorage('reportStime'),
        endTime: this.decryptStorage('reportEtime'),
        vehicleName: this.decryptStorage('carName'),
      };
      this.definition = resolveReportDefinition(this.context);
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  goBack(): void { this.location.back(); }

  private decryptStorage(key: string): string {
    return this.gurdService.decrypt(localStorage.getItem(key)!) || '';
  }
}
